import * as instituicao from '@/api/instituicao'

const state = {
  list: [],
  filtros: { page: 1 },
  countPage: 0,
  modalAdd: false,
  modalEdit: false
}

const mutations = {
  SETINSTITUICOES (state, payload) {
    state.list = payload.list
  },
  LISTREGRASMINIMO (state, payload) {
    state.regrasMinimo = payload
  },
  SETFILTROS (state, payload) {
    if (payload) {
      state.filtros = payload
    }
  },
  SETPAGE (state, payload) {
    state.filtros.page = payload
  },
  SETPAGINATE (state, payload) {
    if (payload === 1) state.countPage = 0
    else state.countPage = payload
  },
  HIDEMODAL (state) {
    state.modalAdd = false
    state.modalEdit = false
    state.modalConfDel = false
  },
  MODALADD (state) {
    state.modalAdd = !state.modalAdd
  },
  MODALEDIT (state) {
    state.modalEdit = !state.modalEdit
  }
}

const actions = {
  async get ({ commit }, payload) {
    let data = await instituicao.get(payload)
    return data
  },
  async getInstituicoes ({ commit }, payload) {
    commit('SETFILTROS', payload)
    let data = await instituicao.getInstituicoes(payload)
    commit('SETINSTITUICOES', data)
    commit('SETPAGINATE', data.pages)
  },
  async getInstituicoesFiltro ({ commit, dispatch }) {
    let data = await instituicao.getInstituicoes(state.filtros)
    if (state.filtros.page > data.pages) dispatch('setPage', data.pages)
    else {
      commit('SETINSTITUICOES', data)
      commit('SETPAGINATE', data.pages)
    }
  },
  setPage (context, payload) {
    context.commit('SETPAGE', payload)
    context.dispatch('getInstituicoes', state.filtros)
  },
  async add ({ commit }, payload) {
    return instituicao.add(payload)
  },
  async edit ({ commit }, payload) {
    return instituicao.edit(payload)
  },
  hideModal: function ({ commit }) {
    commit('HIDEMODAL')
  },
  modalAdd: function ({ commit }) {
    commit('MODALADD')
  },
  modalEdit: function ({ commit }) {
    commit('MODALEDIT')
  }
}

export default { namespaced: true, state, mutations, actions }



// WEBPACK FOOTER //
// ./src/store/modules/gerenciador/instituicoes.js